import DataGrid, { Column } from 'devextreme-react/data-grid';
import moment from 'moment';
import React, { useMemo } from 'react';
import { Alert, Col, Input, Row } from 'reactstrap';
import useFormatMessage from '../../../utils/useFormatMessage';

const AracBilgileri = ({ vehicleData }) => {
    const { t } = useFormatMessage();


    const blockingStatus = useMemo(() => {
        const hasGeneralBlock = vehicleData?.blocking || false;
        const hasDealerBlock = vehicleData?.blocking_shipping || false;

        return {
            hasAnyBlock: hasGeneralBlock || hasDealerBlock,
            generalBlock: hasGeneralBlock,
            dealerBlock: hasDealerBlock
        };
    }, [vehicleData]);

    const vehicleStatus = useMemo(() => {
        if (!vehicleData) return "";
        if (vehicleData.delivery_date && !vehicleData.is_active) return "Teslim Edildi";
        if (!vehicleData.is_active) return "Stokta Değil";
        if (vehicleData.warehouse_name === "GEMİ") return "Gemiye Yüklü";
        if (vehicleData.zone_name?.toLowerCase().includes("rıhtım") ||
            vehicleData.zone_name?.toLowerCase().includes("rihtim")) return "Rıhtımda";
        if (vehicleData.warehouse_name === "TIR") return "Depolar Arası Transfer Durumunda!";
        return "Stokta!";
    }, [vehicleData]);

    const parkAddress = useMemo(() => {
        if (!vehicleData) return "";
        return vehicleData.is_active === false ? "STOKTA DEĞİL" :
            `${vehicleData.warehouse_name || ""} ${vehicleData.zone_name || ""} ${vehicleData.address_code || ""}`.trim();
    }, [vehicleData]);

    const formatDate = (date) => date ? moment(date).format("DD/MM/yyyy HH:mm") : "";

    const isMilli = (value) => {
        if (value === "ithal") {
            return "Hayır"
        } else if (value === "milli") return "Evet"
        return ""
    }

    return (
        <>
            {/* Blokaj Alertleri */}
            {blockingStatus.hasAnyBlock && (
                <div className="mb-3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                    {blockingStatus.generalBlock && (
                        <Alert color="info" className="d-flex align-items-center m-0">
                            <i className="fa fa-info-circle me-2"></i>
                            {t("Bu araçta genel blokaj bulunmaktadır.")}
                        </Alert>
                    )}
                    {blockingStatus.dealerBlock && (
                        <Alert color="danger" className="d-flex align-items-center m-0">
                            <i className="fa fa-exclamation-triangle me-2"></i>
                            {t("Bu araçta bayi blokajı bulunmaktadır.")}
                        </Alert>
                    )}
                </div>
            )}

            <Row>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Model")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={vehicleData?.model || ""} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Son Hareket")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={vehicleData?.end_process || ""} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Renk")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={vehicleData?.color || ""} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500", whiteSpace: "break-spaces" }}>
                                {t("Son Hareket Tarihi")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={formatDate(vehicleData?.end_process_date)} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Durum")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={vehicleStatus} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("PDI Durumu")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={vehicleData ? `${vehicleData.pdi_status ? "PDI Yapılmış " : "PDI Yapılmamış!"} ${formatDate(vehicleData.pdi_exit_date)}` : ""} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Park Adres")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <textarea
                                    value={parkAddress}
                                    disabled
                                    style={{
                                        width: "100%",
                                        resize: "none",
                                        background: "#e9ecef",
                                        minHeight: "38px",
                                        padding: "0.375rem 0.75rem"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                {t("Millileşme Durumu")}
                            </div>
                            <div className="dx-field-value col-md-8">
                                <Input value={isMilli(vehicleData?.domestic_area) || ""} disabled />
                            </div>
                        </div>
                    </div>
                </Col>
                {vehicleData?.customs_declaration_no && (
                    <Col lg="6">
                        <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                            <div className="dx-field mb-2 row">
                                <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                    {t("Beyanname No")}
                                </div>
                                <div className="dx-field-value col-md-8">
                                    <Input value={vehicleData.customs_declaration_no} disabled />
                                </div>
                            </div>
                        </div>
                    </Col>
                )}
                {vehicleData?.customs_clearance_date && (
                    <Col lg="6">
                        <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                            <div className="dx-field mb-2 row">
                                <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                    {t("Gümrüklenme Tarihi")}
                                </div>
                                <div className="dx-field-value col-md-8">
                                    <Input value={formatDate(vehicleData.customs_clearance_date)} disabled />
                                </div>
                            </div>
                        </div>
                    </Col>
                )}

                <Col lg="6">
                    <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                        <div className="dx-field mb-2 row">
                            <DataGrid
                                dataSource={vehicleData?.invoice_data || []}
                                height={120}
                                showColumnLines={true}
                                showRowLines={true}
                                showBorders={true}
                                wordWrapEnabled={true}
                                columnAutoWidth={true}
                                noDataText={t("Fatura bilgisi bulunamadı")}
                            >
                                <Column
                                    dataField="bilgi_tarihi"
                                    caption={t("Bilg. Trh.")}
                                    dataType="date"
                                    format="dd/MM/yyyy HH:mm"
                                />
                                <Column
                                    dataField="fatura_tarihi"
                                    caption={t("Fatura Tarih")}
                                    dataType="date"
                                    format="dd/MM/yyyy"
                                />
                                <Column dataField="fatura_no" caption={t("Fatura No")} />
                                <Column dataField="fatura_bayi" caption={t("Fatura Bayi")} />
                            </DataGrid>
                        </div>
                    </div>
                </Col>

                <Col lg="6">

                    <Row>
                        <Col lg="12">
                            <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                                <div className="dx-field mb-2 row">
                                    <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                        {t("Öncelik Puanı")}
                                    </div>
                                    <div className="dx-field-value col-md-8">
                                        <Input
                                            value={vehicleData?.priority_data || ""}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg="12">
                            <div className="dx-fieldset m-1" style={{ margin: "12px 7px" }}>
                                <div className="dx-field mb-2 row">
                                    <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                                        {t("Teslim Tarihi")}
                                    </div>
                                    <div className="dx-field-value col-md-8">
                                        <Input
                                            value={vehicleData?.delivery_date ? moment(vehicleData.delivery_date).format("DD.MM.YYYY") : "-"}
                                            disabled

                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Col>

                {/* Stok Durumu Uyarısı */}
                {vehicleData && !vehicleData.is_active && (
                    <Col lg="6">
                        <Alert color={(vehicleData.delivery_date && !vehicleData.is_active) ? "success" : "dark"} className="mt-4 d-flex align-items-center">
                            {
                                (vehicleData.delivery_date && !vehicleData.is_active) ?
                                    <span className="me-2" role="img" aria-label="warning">✅</span> :
                                    <span className="me-2" role="img" aria-label="warning">⚠️</span>
                            }

                            <div style={{ fontSize: "17px" }}>  &nbsp;
                                <strong style={{ color: (vehicleData.delivery_date && !vehicleData.is_active) ? "#ffde00" : "#ffffff" }}>
                                    {
                                        (vehicleData.delivery_date && !vehicleData.is_active) ?
                                            t("TESLİM EDİLDİ") :
                                            t("UYARI!")
                                    }
                                </strong> &nbsp;
                                {
                                    (vehicleData.delivery_date && !vehicleData.is_active) ?
                                        t("Bu şase sevk noktasına teslim edilmiştir.") :
                                        t("Bu şase şu anda stokta aktif değildir.")
                                }

                            </div>
                        </Alert>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default AracBilgileri;
